// extracted by mini-css-extract-plugin
export default {"colStyle":"categories_colStyle__hwYi9","colHead":"categories_colHead__HVF8g"};